var t, a;
function o() {
  if (a) return t;
  a = 1;
  return t = class {
    constructor(t) {
      this.lookup = t, this.data = {};
    }
    add(t, a) {
      this.lookupFieldIsPopulated(a) && (this.data[t] = this.formatData(this.lookup[a]));
    }
    addCustomParameter(t, a) {
      this.data[t] = a;
    }
    formatData(t) {
      return Array.isArray(t) ? t.join(";") : t;
    }
    lookupFieldIsPopulated(t) {
      return "" !== this.lookup[t] && void 0 !== this.lookup[t];
    }
  };
}
export { o as __require };